import { render, staticRenderFns } from "./LocalLoader.vue?vue&type=template&id=47b46326&scoped=true"
import script from "./LocalLoader.vue?vue&type=script&lang=js"
export * from "./LocalLoader.vue?vue&type=script&lang=js"
import style0 from "./LocalLoader.vue?vue&type=style&index=0&id=47b46326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b46326",
  null
  
)

export default component.exports